<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { logicHotSeriesRank } from '@/logic/rank/hotSeries'

const props = withDefaults(defineProps<{
  embedded?: boolean
}>(), {
  embedded: true,
})

const {
  state,
  data,
  getRankData,
} = logicHotSeriesRank()

await getRankData()
</script>

<template>
  <n-card
    title="热门车系" :embedded="props.embedded" size="small"
    class="rounded-md"
    header-style="--n-title-font-weight: bold;"
  >
    <template #header-extra>
      <span class="text-red-4 text-3.25">投诉量<span font-bold text-2.5>/</span>宗</span>
    </template>
    <UtilLoadState :state="state" :reload-handler="getRankData">
      <template v-if="data.length">
        <NuxtLink
          v-for="(v, i) in data" :key="i"
          class="mb-sm text-3.5 flex items-center last:mb-0"
          :to="APP_ROUTER.reputationDetail(v.carSeriesId)"
        >
          <span class="rank mr-2.5" :class="`rank__${i}`">{{ i + 1 }}</span>
          <span class="line-clamp-1 text-3.5 hover:text-orange-6 font-bold flex-grow">
            {{ v.carSeriesName }}<span class="text-3 font-normal ml-1 text-slate-5">({{ v.carVendorName }})</span>
          </span>
          <span class="text-red-5 ml-sm text-4 font-mono">
            {{ v.complainCount }}
          </span>
        </NuxtLink>
      </template>
      <BasicEmpty v-else />
    </UtilLoadState>
  </n-card>
</template>

<style lang='scss' scoped>
@import url(@/assets/styles/rank.scss);
</style>
